export const updateGlobalState = (payload) => {
    return {
        type : 'UPDATE_GLOBAL_STATE',
        payload
    }
}
